// Email → templateId eşlemesi (backend henüz saklamıyor; localStorage geçici çözüm).
const STORAGE_KEY = "pupill:adminUserTemplates";

function loadMap() {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_e) { return {}; }
}

function saveMap(map) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map || {}));
  } catch (_e) { /* yut */ }
}

export function getUserTemplateId(email) {
  if (!email) return null;
  const map = loadMap();
  return map[String(email).toLowerCase()] || null;
}

export function setUserTemplateId(email, templateId) {
  if (!email) return;
  const map = loadMap();
  if (templateId) map[String(email).toLowerCase()] = templateId;
  else delete map[String(email).toLowerCase()];
  saveMap(map);
}

export function getAllMappings() {
  return loadMap();
}
